import React from "react";
import { SlidePages } from "../../components/slidePages";
import { ContactMap } from "../../components/contactMap";
import ContactForm from "../../components/contactForm";
import img from "../../assets/images/contact-m.png"; // Import the image

export const ContactPage = () => {
  return (
    <div>
      {" "}
      <SlidePages
        title={"Contactez Habitat IDF"}
        description={
          "Besoin d’un devis, d’un diagnostic ou d’un accompagnement pour vos travaux ? Contactez-nous, notre équipe vous répond sous 48h."
        }
      />
      <div className="map-img d-md-none d-block d-flex justify-content-center mt-5">
        <img src={img} alt="Bento Habitat" className="img-fluid " />
      </div>
      <ContactMap />
      <ContactForm />
    </div>
  );
};
